<template>
    <div style="display:inline-block;">
        <v-popover
            offset="16"
            :options="options"
            style="display:inline-block;"
            :open="show"
            placement="left"
        >
            <button class="tooltip-target b3" style="display:inline-block;" @mouseover="show = true" @mouseleave="show = false">
                <i class="fas fa-info-circle fa-fw" />
            </button>

            <template slot="popover">
                <div class="line title" v-if="title">{{ title }}</div>
                <template v-for="(line, index) in lines">
                    <div class="divider" style="margin:10px 0;" v-if="line.total" :key="'d' + index"></div>
                    <div class="line" :class="{ total: line.total }" :key="index">
                        <div class="left">
                            {{ line.label }}
                            <br v-if="line.formula"><span class="formula" v-if="line.formula">{{ line.formula }}</span>
                        </div>
                        <div class="right">{{ line | lineAmount }}</div>
                    </div>
                </template>
            </template>
        </v-popover>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .tooltip-target {
        opacity: .5;

        &:hover {
            opacity: 1;
        }
    }

    .line {
        min-width: 250px;
        display: flex;
        justify-content: space-between;
        white-space: nowrap;
        margin-bottom: $margin--small / 2;
        font-weight: 600;

        .left {
            margin-right: 30px;
        }

        .formula {
            opacity: 0.5;
            font-size: 12px;
            font-weight: 400;
        }

        &.title {
            font-weight: 700;
            margin-bottom: $margin--small;
        }

        &.total {
            margin-bottom: 0;
            font-weight: 700;
        }
    }
</style>

<script>
export default {
    props: {
        title: String,
        lines: Array
    },
    data () {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        }
    },
    filters: {
        lineAmount (line) {
            if (line.unit === 't') {
                return line.amount.toLocaleString('da-DK') + ' t'
            }
            return line.amount.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr.'
        }
    }
}
</script>



// WEBPACK FOOTER //
// calcTooltip.vue?94d62c1a